import { createFocusTrap } from 'focus-trap'

export default function ({ el }) {
    const INACTIVE_CLASS = 'hidden'
    const button = el.querySelector('button')
    const navigation = el.querySelector('div')
    const focusTrap = createFocusTrap(el, {
        clickOutsideDeactivates: true,
    })

    if (!button || !navigation) {
        return
    }

    const onKeyUp = (event) => {
        if (event.key === 'Escape') {
            close()
        }
    }

    const onClick = (event) => {
        if (!navigation.contains(event.target)) {
            close()
        }
    }

    const open = () => {
        navigation.classList.remove(INACTIVE_CLASS)
        navigation.setAttribute('aria-hidden', 'false')
        button.setAttribute('aria-expanded', 'true')
        focusTrap.activate()

        setTimeout(() => {
            document.addEventListener('click', onClick)
            window.addEventListener('keyup', onKeyUp)
        })
    }

    const close = () => {
        navigation.classList.add(INACTIVE_CLASS)
        navigation.setAttribute('aria-hidden', 'true')
        button.setAttribute('aria-expanded', 'false')
        document.removeEventListener('click', onClick)
        window.removeEventListener('keyup', onKeyUp)
        focusTrap.deactivate()
    }

    const toggle = () => {
        if (navigation.classList.contains(INACTIVE_CLASS)) {
            open()
        } else {
            close()
        }
    }

    button.addEventListener('click', toggle)
}
